export default {
    dashboard: 'dashboard',
    clock: 'clock',
    specials: 'specials',
    devices: 'devices',
    messages: 'messages',
    applications: 'applications',
    users: 'users',
    repairs: 'repairs'
};